<div class="container report-container" id="print-section">

  <div style="margin-left: 80%; margin-bottom: 2%">
    <button id="print-button" class="noPrint" style="margin-top: 2%; margin-left: 2%; display: none;" mat-raised-button
      color="primary" printSectionId="print-section" [useExistingCss]="true" ngxPrint>
      Print
    </button>

    <button (click)="print()" class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary">
      Print
    </button>
    <button mat-dialog-close class="btn noPrint">Close</button>
  </div>
  <div style="margin: 25px; margin-right: 40px; page-break-after: always;">

    <!-- Header Table -->
    <table class="header-table">
      <tr>
        <th style="width: 30%;font-size: 22px;">विवेक साप्ताहिक</th>
        <th style="width: 40%;font-size: 22px;">जाहिरात प्रसिद्धीपत्रक</th>
        <th style="width: 30%;font-size: 12px;">
          Date : {{ today | date:"dd-MM-yyyy"}} <br>
          Page No : 1
        </th>
      </tr>
      <tr>
        <td style="font-size: 18px;">Date From: {{ start_date | date:"dd-MM-yyyy" }} To: {{ end_date | date:"dd-MM-yyyy"
          }}</td>
        <td style="font-size: 18px;"> Issue Name </td>
        <td style="font-size: 18px;">Issue Date </td>

      </tr>
      <tr>
        <td style="font-size: 18px;">Issue/Grantha Category : {{ issue_category }}</td>
        <td style="font-size: 18px;">{{ issuenamenew }}</td>
        <td style="font-size: 18px;">
          {{ issuedatepp | date:"dd-MM-yyyy" }}
        </td>
      </tr>
    </table>

    <!-- Data Section -->
    <!-- Data Section -->
    <div class="data-section">
      <table border="1" cellspacing="0" cellpadding="5" style="border-collapse: collapse; width: 100%;">
        <!-- Table Header -->
        <thead>
          <tr style="background: #f2f2f2; font-weight: bold; text-align: center;">
            <th style="font-size: 15px;font-weight: bold;border: 1px solid black;">अनु<br>अ.</th>
            <th style="font-size: 15px;font-weight: bold;border: 1px solid black;">नोंदणी<br>क्र</th>
            <th
              style="font-size: 15px;font-weight: bold; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 260px;border: 1px solid black;">
              जाहिरातदाराचे नाव
            </th>
            <th style="font-size: 15px;font-weight: bold;width: 13%;border: 1px solid black;">ग्राहक नाव</th>

            <!-- ✅ Checkbox inside th -->
            <th style="border: 1px solid black; padding: 8px; width: 5%; text-align: center;">
              <input type="checkbox" [(ngModel)]="selectAll" (change)="onSelectAll($event)"
                style="width: 16px; height: 16px; cursor: pointer;" />
            </th>

            <th style="font-size: 15px;font-weight: bold;width:20%;border: 1px solid black;">जाहिरात आकार</th>
            <th style="font-size: 15px;font-weight: bold;border: 1px solid black;">जाहि-सूचना</th>
            <th style="font-size: 15px;font-weight: bold;text-align:center;width: 9%;border: 1px solid black;">
              पृष्ठ<br>क्र</th>
            <th style="font-size: 15px;font-weight: bold;text-align:center;width: 9%;border: 1px solid black;">रक्कम
            </th>
          </tr>
        </thead>

        <tbody>

          <!-- Data Loop -->
          <ng-container *ngFor="let data of prasiddhipatrakData; let i = index;">

            <!-- Group Header -->
            <tr>
              <td colspan="9"
                style="padding: 8px; background-color:#88cbe9; color: rgb(8, 8, 8); border: 1px solid black;">
                <b>जाहिरात आकार : </b> <b style="font-size: 16px;">{{data.advt_size}}</b>
              </td>
            </tr>


            <!-- Row Loop -->
            <tr *ngFor="let data1 of data.advt_data; let j = index;" style="border-bottom: 1px solid black;">
              <td style="text-align: center; font-size: 14px; border: 1px solid black;">{{data1.advt_count}}</td>
              <td style="border: 1px solid black;">{{data1.booking_no}}</td>
              <td
                style="font-size: 16px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 260px; border: 1px solid black;">
                {{data1.name | slice :0:40}}
              </td>
              <td style="border: 1px solid black;">{{data1.cust_name}}</td>

              <td style="border: 1px solid black; text-align: center; padding: 8px;">
                <input type="checkbox" [(ngModel)]="data1.isSelected" (change)="onItemCheckChange()"
                  style="width: 16px; height: 16px; cursor: pointer;" />
              </td>

              <td style="font-size: 14px; border: 1px solid black;">{{data1.DS_advtsize}}</td>
              <td style="font-size: 13px; border: 1px solid black;">{{data1.instruction | slice : 0 :15}}</td>
              <td style="text-align: center; font-size: 15px; border: 1px solid black;">{{data1.pages_no}}</td>
              <td style="text-align: right; font-size: 15px; border: 1px solid black;">{{data1.net_amt}}</td>
            </tr>

            <!-- Sub Total -->
            <tr>
              <td colspan="9" style="padding: 8px; border: 1px solid black;">
                <b>एकूण जाहिरात आकार: {{data.advt_size}} : {{data.total_count}}</b>
              </td>
            </tr>
          </ng-container>
        </tbody>


        <!-- Total -->
        <tr style="background-color: #11cdef;">
          <td colspan="8" style="border: 1px solid black; padding: 8px; text-align: right;"><b>Total</b></td>
          <td style="border: 1px solid black; padding: 8px; text-align: center;"><b>{{total_count}}</b></td>
        </tr>
      </table>

      <!-- Signatures -->
      <br />
      <div class="signature-section">
        <table class="signature-table">
          <tr>
            <td>स्वाक्षरी जाहिरात विभाग - लिपिक</td>
            <td>कार्यालय प्रमुख</td>
          </tr>
          <tr>
            <td>संपादकीय विभागाकरिता - लिपिक</td>
            <td>दिनांक :</td>
          </tr>
        </table>
      </div>
    </div>

  </div>

  <!-- Summary Section -->

  <!-- Added header section -->
  <!-- Header section -->
  <!-- 
  <div style="margin: 25px;">
   
  <table class="summary-table">
    <thead>
<tr>
    <td style="font-size: 18px; text-align: left;">
      <strong>Issue Name</strong><br />
      {{ issuenamenew }}
    </td>
    <td style="font-size: 18px; text-align: right;">
      <strong>Issue Date</strong><br />
      {{ issuedatepp | date:'dd-MM-yyyy' }}
    </td>
  </tr>

    </thead>
    <thead>
      <tr>
        <th>अंक अ.</th>
        <th>जाहिरात आकार</th>
        <th>संख्या</th>
        <th>एकूण पानाची संख्या</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of prasiddhipatraksummary; let i = index;">
        <td>{{ i+1 }}</td>
        <td>{{ item['advtsize'] }}</td>
        <td>{{ item['total'] }}</td>
        <td></td>
        <td></td>
      </tr>
      <tr class="total-row">
        <td></td>
        <td>Total</td>
        <td>{{ total_count }}</td>
        <td></td>
        <td></td>
      </tr>
    </tbody>
  </table>
</div> -->


  <div style="margin: 25px;">
    <table class="summary-table" style="width: 100%; border-collapse: collapse; border: 1px solid black;">
      <thead>
        <!-- Header row for Issue Name and Issue Date -->
        <tr class="info-header">
          <th colspan="2" style="border: 1px solid black; padding: 8px; text-align: left; font-size: 16px;">
            <strong>Issue Name:</strong> {{ issuenamenew }}
          </th>
          <th colspan="3" style="border: 1px solid black; padding: 8px; text-align: left; font-size: 16px;">
            <strong>Issue Date:</strong> {{ issuedatepp | date:'dd-MM-yyyy' }}
          </th>
        </tr>

        <!-- Column headers -->
        <tr>
          <th style="border: 1px solid black; padding: 8px;">अंक अ.</th>
          <th style="border: 1px solid black; padding: 8px;">जाहिरात आकार</th>
          <th style="border: 1px solid black; padding: 8px;">संख्या</th>
          <th style="border: 1px solid black; padding: 8px;">एकूण पानाची संख्या</th>
          <th style="border: 1px solid black; padding: 8px;"></th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let item of prasiddhipatraksummary; let i = index;">
          <tr>
            <td style="border: 1px solid black; text-align: center; padding: 8px;">{{ i + 1 }}</td>
            <td style="border: 1px solid black; padding: 8px; text-align: left;">{{ item['advtsize'] }}</td>
            <td style="border: 1px solid black; text-align: center; padding: 8px;">{{ item['total'] }}</td>
            <td style="border: 1px solid black; padding: 8px;"></td>
            <td style="border: 1px solid black; padding: 8px;"></td>
          </tr>

          <!-- Blank separator row after color data (index 7 = 8th row) -->
          <tr *ngIf="i === 7" class="print-padding">
            <td style="border: 1px solid black; padding: 15px; background-color: #e8e8e8;"></td>
            <td style="border: 1px solid black; padding: 15px; background-color: #e8e8e8;"></td>
            <td style="border: 1px solid black; padding: 15px; background-color: #e8e8e8;"></td>
            <td style="border: 1px solid black; padding: 15px; background-color: #e8e8e8;"></td>
            <td style="border: 1px solid black; padding: 15px; background-color: #e8e8e8;"></td>
          </tr>
        </ng-container>

        <tr class="total-row">
          <td style="border: 1px solid black; padding: 8px;"></td>
          <td style="border: 1px solid black; padding: 8px; text-align: left;"><strong>Total</strong></td>
          <td style="border: 1px solid black; text-align: center; padding: 8px;"><strong>{{ total_count }}</strong></td>
          <td style="border: 1px solid black; padding: 8px;"></td>
          <td style="border: 1px solid black; padding: 8px;"></td>
        </tr>
      </tbody>
    </table>
  </div>



</div>